import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import { CopyIcon, EditIcon, TrashIcon } from "../../components/SVGIcon";

export const TitleSchema = {
  name: "Title",
  tag: "Title",
  fields:[
    {
      type: "text",
      label: "",
      placeholder: "",
      selectedDropdownValue: "",
      value: "",
      isDigital: true,
    }
  ]
}

const TitleSection = ({ 
  singleDefaultElementTypes,
  markSectionEditing,
  updateSection,
  templateId,
  templateType,
  conversationData,
  section,
  index,
  dropdownOptions,
  updateTemplateName,
  isCreateReportRoute
}) => {
  const [showModal, setShowModal] = useState(false);
  const [fields, setFields] = useState([]);
  const [isEditModeOn, setIsEditModeOn] = useState(false);

  useEffect(() => {
    setFields(section?.fields ?? []);
  }, [section, isEditModeOn]);

  // useEffect(() => {
  //   setIsEditModeOn(false);
  // }, []);

  const handleDeleteSection = () => {
    updateSection(section.id, null); // parent removes it
    setShowModal(false);
  };

  const handleChange = (row, newLabel) => {
    // only update local fields state → no re-render from templateJson
    setFields((prev) =>
      prev.map((f, i) => (i === row ? { ...f, label: newLabel } : f))
    );
    if(isCreateReportRoute){
      updateTemplateName(newLabel)
    }
    

  };

  const resetFields = () => {
    setFields(section?.fields ?? []);
    exitEditMode();
  };

  const exitEditMode = () => {
    setIsEditModeOn(() => false);
    markSectionEditing(section.id, false);
  };

  const handleEditStart = () => {
    setIsEditModeOn(() => true);
    markSectionEditing(section.id, true);
  };

  const handleSave = () => {
    updateSection(section.id, prevSection => ({
      ...prevSection,
      // name: localSectionName,
      fields: [...fields],
    }));
    exitEditMode();
  };

  // const handleSave = (value, row) => {
  //   if (!isEditModeOn) return; // only sync when in edit mode
    
  //   // push local field changes back to templateJson
  //   setTemplateJson((prev) => {
  //     const updatedSchema = prev.schema.map((schem) =>
  //       schem.id === section.id
  //         ? { ...schem, fields: fields }
  //         : schem
  //     );
  //     if(isCreateReportRoute){
  //       return { ...prev, name: value, schema: updatedSchema };
  //     }else{
  //       return { ...prev, schema: updatedSchema };
  //     }
      
  //   });
  //   // updateStateInformation(newLabel, setTemplateJson, "name")
  // };

  return (
    <>
      <div className="bg-gray-800 rounded-3 p-3">
        {fields?.map((element, row) => (
          <Row key={row} className="align-items-center position-relative">
            <Col className="flex-grow-1">
              {isEditModeOn ? (
                <input
                  id={element?.label}
                  className="form-control h-auto fs-48 fw-bold text-white text-center mb-0 w-100"
                  style={{
                    background: "transparent",
                    border: "1px solid #0D79FF",
                  }}
                  value={element?.label}
                  onChange={(e) => handleChange(row, e.target.value)}
                  // onBlur={(e) => handleBlur(e.target.value, row)}
                />
              ) : (
                <p className="fs-48 fw-bold text-white text-center mb-0 w-100">{element?.label}</p>
              )}
            </Col>
            <Col className="flex-grow-0 position-absolute end-0 w-auto">
              <div className="d-flex align-items-center gap-1">
              {!isEditModeOn &&
                <Button variant="icon" className="btn-md text-blue-600" onClick={handleEditStart}>
                  <EditIcon />
                </Button>
              }
                {!isEditModeOn && !isCreateReportRoute && <Button
                  variant="icon"
                  className="btn-md text-red-600"
                  onClick={() => setShowModal(true)}
                >
                  <TrashIcon />
                </Button>}
              </div>
            </Col>
          </Row>
        ))}

        {isEditModeOn && (
          <Row className="gy-2 gy-sm-0 mt-4">
            <Col md="8" className="d-flex align-items-center gap-2">
              <Button
                variant="primary"
                className="btn-md"
                onClick={handleSave}
              >
                Save & Update
              </Button>
              <Button
                variant="outline-secondary"
                className="btn-md"
                onClick={(e) => (resetFields(), setIsEditModeOn(!isEditModeOn))}
              >
                Cancel
              </Button>
            </Col>
            {!isCreateReportRoute && <Col md="4" className="text-sm-end">
              <Button
                variant="danger-light"
                className="btn-md"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Delete Section
              </Button>
            </Col>}
          </Row>
        )}
      </div>
      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={handleDeleteSection}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default TitleSection;
